/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  MeiTiChaXunDTO,
  MeiTiChuangJianDTO,
  MeiTiFenChengBiLiGengXinDTO,
  MeiTiGengXinDTO,
  ResponseApiIPageMeiTiLieBiaoXiangYingDTO,
  ResponseApiLong,
  ResponseApiMeiTiLieBiaoXiangYingDTO,
  ResponseApiVoid,
} from "./data-contracts";
import { HttpClient, RequestParams, ContentType } from '@gatherstar/utils';

export class MeiTiGuanLi<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags MeiTiGuanLi
   * @name CreatePublisherUsingPost
   * @summary 创建媒体
   * @request POST:/dsp-admin/api/publisher/create
   * @secure
   */
  createPublisherUsingPost = (
    createDTO: MeiTiChuangJianDTO,
    params: RequestParams = {},
  ) =>
    this.request<ResponseApiLong, void>({
      path: `/dsp-admin/api/publisher/create`,
      method: "POST",
      body: createDTO,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags MeiTiGuanLi
   * @name PublisherListUsingPost
   * @summary 分页查询媒体列表
   * @request POST:/dsp-admin/api/publisher/list
   * @secure
   */
  publisherListUsingPost = (
    queryDTO: MeiTiChaXunDTO,
    params: RequestParams = {},
  ) =>
    this.request<ResponseApiIPageMeiTiLieBiaoXiangYingDTO, void>({
      path: `/dsp-admin/api/publisher/list`,
      method: "POST",
      body: queryDTO,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags MeiTiGuanLi
   * @name GetPublisherByIdUsingGet
   * @summary 获取媒体信息
   * @request GET:/dsp-admin/api/publisher/{id}
   * @secure
   */
  getPublisherByIdUsingGet = (id?: number, params: RequestParams = {}) =>
    this.request<ResponseApiMeiTiLieBiaoXiangYingDTO, void>({
      path: `/dsp-admin/api/publisher/${id}`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags MeiTiGuanLi
   * @name UpdatePublisherUsingPut
   * @summary 更新媒体
   * @request PUT:/dsp-admin/api/publisher/{id}
   * @secure
   */
  updatePublisherUsingPut = (
    updateDTO: MeiTiGengXinDTO,
    id?: number,
    params: RequestParams = {},
  ) =>
    this.request<ResponseApiLong, void>({
      path: `/dsp-admin/api/publisher/${id}`,
      method: "PUT",
      body: updateDTO,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags MeiTiGuanLi
   * @name DeletePublisherUsingDelete
   * @summary 删除媒体
   * @request DELETE:/dsp-admin/api/publisher/{id}
   * @secure
   */
  deletePublisherUsingDelete = (id?: number, params: RequestParams = {}) =>
    this.request<ResponseApiVoid, void>({
      path: `/dsp-admin/api/publisher/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags MeiTiGuanLi
   * @name UpdatePublisherShareRatioUsingPut
   * @summary 更新媒体分成比例
   * @request PUT:/dsp-admin/api/publisher/{id}/share-ratio
   * @secure
   */
  updatePublisherShareRatioUsingPut = (
    shareRatioUpdateDTO: MeiTiFenChengBiLiGengXinDTO,
    id?: number,
    params: RequestParams = {},
  ) =>
    this.request<ResponseApiLong, void>({
      path: `/dsp-admin/api/publisher/${id}/share-ratio`,
      method: "PUT",
      body: shareRatioUpdateDTO,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
}


// 导出默认实例，可直接使用
export const api = new MeiTiGuanLi();
